import { ProviderAuditResourceKind } from '../../../provider-audit-resource-kind';
import { ReportProfileDelegateAccess } from '../../../profile/report-profile-delegate-access';
import { ReportProfileDeviceSyncModel } from '../../../profile/report-profile-device-sync-model';

export class ExchangeReportProfileDelegate extends ReportProfileDelegateAccess {
  resourceKind: ProviderAuditResourceKind;
  devices: ReportProfileDeviceSyncModel[];
}
